import { React, useEffect, useState, useContext } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { Multiselect, StudentTable, StudentOverview } from "..";
import { UserContext } from "../../App";
import "../../styles/StudentSearch.css";

function StudentSearch() {
  const { userType } = useContext(UserContext);
  const [studentName, setStudentName] = useState("");
  const [gradYear, setGradYear] = useState([]);
  const [csType, setCSType] = useState([]);
  const [updateTable, setUpdateTableHook] = useState(false);
  const [availableGradYears, setAvailableGradYears] = useState([]);

  const setUpdateTable = (value) => {
    setUpdateTableHook(value);
    setSelectedStudent({});
  };

  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState({});

  useEffect(() => {
    showStudentSearchResults();
  }, [studentName, gradYear, csType, updateTable]);

  useEffect(() => {
    axios.get("/company/graduationYears").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableGradYears(data.gradYears);
      } else {
        return setAvailableGradYears([]);
      }
    });
  }, [updateTable]);

  const showStudentSearchResults = () => {
    const body = new FormData();
    body.append("studentName", studentName);
    body.append("gradYear", gradYear);
    body.append("csType", csType);

    axios.post("/student/searchStudents", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setStudents(data.students);
      } else {
      }
    });
  };

  const majorMinorData = {
    label: "Major/Minor",
    options: ["Major", "Minor"],
    value: csType,
    setter: setCSType,
  };

  const gradYearData = {
    label: "Graduation Year",
    options: availableGradYears,
    value: gradYear,
    setter: setGradYear,
  };

  function makeMultiselect(type) {
    let data = {};
    if (type === "Graduation Year") {
      data = gradYearData;
    } else if (type === "Major/Minor") {
      data = majorMinorData;
    } else {
      return;
    }

    return (
      <Multiselect
        label={data.label}
        options={data.options}
        selectedValue={data.value}
        selectedSetter={data.setter}
        key={data.label}
      />
    );
  }

  const compileResumes = () => {
    const body = new FormData();
    // Get all pids from the students list
    const pids = students.map((student) => student.pid);
    body.append("pids", pids);
    axios.post("/student/compileResumes", body, { responseType: "blob" }).then((res) => {
      // If the file exists
      if (res.data.size === 0) {
        alert("No resumes found");
        return;
      }
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "resumes.zip";
      document.body.appendChild(link);
      link.click();
      link.remove(); // Remove the link element from the DOM after the download has started
      window.URL.revokeObjectURL(url);
    });
  };

  const resetHooks = () => {
    //setLastName("");
    setStudentName("");
    setGradYear([]);
    setCSType([]);
  };

  function showSearchDropdowns() {
    return ["Graduation Year", "Major/Minor"].map((dataType) => {
      return makeMultiselect(dataType);
    });
  }

  return (
    <div className="StudentSearch bg-brand-tertiary">
      <div className="StudentSearch-container flex flex-col p-8 h-full">
        <div className="StudentSearch-topContainer flex flex-wrap">
          <div className="StudentSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          {showSearchDropdowns()}

          <button
            type="button"
            className="search-button px-4 h-11 mb-4 mr-4 text-center py-2"
            onClick={compileResumes}
          >
            Compile Current Resumes
          </button>

          <button
            type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2"
            onClick={resetHooks}
          >
            Reset Search
          </button>
        </div>
        <div className="StudentSearch-bottomContainer flex h-full">
          <div className="StudentSearch-leftContainer">
            <StudentTable
              students={students}
              selectedStudent={selectedStudent}
              setStudent={setSelectedStudent}
              userType={userType}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
            />
          </div>
          <div className="StudentSearch-rightContainer">
            <div>
              <StudentOverview student={selectedStudent} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentSearch;
